/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { setRememberMeSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import { getRememberMeSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';

const RememberMeABTest = ({ pageType }) => {
    const dispatch = useDispatch();
    const rememberMeSaleForceABTestData = useSelector(getRememberMeSaleForceABTest);

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        queryName: 'CreateAccountCheckout',
        interactionName: 'Get Campaign - Create account checkout',
        targeting: { pageType },
        featureFlag: true,
    });

    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'RememberMeABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Account create on checkout Page ABTest returned an error',
            jsError: error,
        });
    }
    if (
           data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
           && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== rememberMeSaleForceABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatch(setRememberMeSaleForceABTest(data.contentSF));
    }
    return null;
};

RememberMeABTest.propTypes = {
    pageType: string.isRequired,
};

export default RememberMeABTest;
